// --------------------------------------------------------------------------
// GTM-data pushed to the dataLayer
// --------------------------------------------------------------------------
// Author:      Alix Richards
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2017, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function () {

    function init() {

        $('body').on('click', '[data-gtm]', function () {
            var el = $(this);
            var dataString = el.attr('data-gtm');
            var obj = JSON.parse(dataString);
            dataLayer.push(obj);
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/gtm-data.js
// module id = 506
// module chunks = 0